const IMAGE_PLACEHOLDER_PATH = '/images/pakpoints-placeholder.png';

const asTrimmed = (value) => (typeof value === 'string' ? value.trim() : '');

/** Resolve image URL from API string or { url } object (DRF FileField). */
export const imageFieldUrl = (field) => {
  if (!field) return '';
  if (typeof field === 'string') return asTrimmed(field);
  if (typeof field === 'object' && field.url) return asTrimmed(field.url);
  return '';
};

export const withImagePlaceholder = (src) => asTrimmed(src) || IMAGE_PLACEHOLDER_PATH;

export const firstImageOrPlaceholder = (images = []) => {
  if (!Array.isArray(images)) {
    return IMAGE_PLACEHOLDER_PATH;
  }
  for (const image of images) {
    const candidate =
      imageFieldUrl(image?.original_image) ||
      imageFieldUrl(image?.image) ||
      imageFieldUrl(image?.thumbnail) ||
      imageFieldUrl(image?.medium_image) ||
      imageFieldUrl(image?.large_image);
    if (candidate) {
      return candidate;
    }
  }
  return IMAGE_PLACEHOLDER_PATH;
};

/**
 * Cover image for listings (ads, mosques, institutes, businesses, etc.):
 * display_image, then featured gallery image, then first image.
 */
export const getListingCoverImageUrl = (listing) => {
  if (!listing) return IMAGE_PLACEHOLDER_PATH;

  const display = listing.display_image;
  if (display) {
    const fromDisplay =
      imageFieldUrl(display.original_image) ||
      imageFieldUrl(display.thumbnail) ||
      imageFieldUrl(display.medium_image) ||
      imageFieldUrl(display.large_image);
    if (fromDisplay) return fromDisplay;
  }

  if (Array.isArray(listing.images) && listing.images.length > 0) {
    const featured = listing.images.find((img) => img.is_featured);
    const chosen = featured || listing.images[0];
    const fromChosen =
      imageFieldUrl(chosen?.original_image) ||
      imageFieldUrl(chosen?.thumbnail) ||
      imageFieldUrl(chosen?.medium_image);
    if (fromChosen) return fromChosen;
  }

  return firstImageOrPlaceholder(listing.images);
};

/** @deprecated Use getListingCoverImageUrl — kept for existing ad card imports. */
export const getAdCoverImageUrl = getListingCoverImageUrl;

export { IMAGE_PLACEHOLDER_PATH };
